// Small presentational primitives shared by the operator screens.
// Text-only empty states, skeleton loaders — no illustrations, no gradients,
// no full-page blocking spinners.

export const Panel = ({ title, action, children }) => (
  <div className="bg-white border border-slate-200 rounded-2xl p-5">
    <div className="flex items-center justify-between gap-3 mb-4">
      <h3 className="text-sm font-bold text-slate-900">{title}</h3>
      {action}
    </div>
    {children}
  </div>
);

// Empty states are concrete and encouraging: they name the next action.
export const EmptyText = ({ children }) => (
  <p className="text-xs text-slate-400 leading-relaxed py-6">{children}</p>
);

export const ErrorText = ({ children }) => (
  <p className="text-xs text-red-600 leading-relaxed py-6">{children}</p>
);

export const SkeletonRows = ({ rows = 3 }) => (
  <div className="space-y-2" aria-hidden="true">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="h-10 rounded-lg bg-slate-100 animate-pulse" />
    ))}
  </div>
);

export const Chip = ({ tone = 'slate', children }) => {
  const tones = {
    slate: 'bg-slate-100 text-slate-600 border-slate-200',
    green: 'bg-green-50 text-green-700 border-green-200',
    amber: 'bg-amber-50 text-amber-700 border-amber-200',
    blue: 'bg-blue-50 text-blue-600 border-blue-100',
  };
  return (
    <span className={`inline-block text-[10px] font-bold uppercase px-2 py-0.5 rounded border ${tones[tone]}`}>
      {children}
    </span>
  );
};

// Perfil Aduanero estado → chip. `null` means the client has no perfil row yet.
export const PerfilChip = ({ estado }) => {
  if (!estado) return <Chip tone="slate">Sin perfil</Chip>;
  if (estado === 'activado') return <Chip tone="green">Activado</Chip>;
  if (estado === 'revisión_requerida') return <Chip tone="amber">Revisión</Chip>;
  return <Chip tone="slate">Pendiente</Chip>;
};
